import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { Card, CardHeader, CardContent } from '../components/Card';
import { Badge } from '../components/Badge';
import { ArrowRight, Check, Calendar, Clock, Users, TrendingUp, Zap, Coffee, MessageSquare, Loader2, CrownIcon, HandshakeIcon, SparklesIcon, CalendarCheckIcon, GlobeIcon, VideoIcon, LayersIcon, FileTextIcon, MenuIcon, XIcon, MapPinIcon, Gamepad2Icon, LaptopIcon, PartyPopperIcon } from 'lucide-react';
interface NetworkingSalonExperiencePageProps {
  onNavigate?: (path: string) => void;
}
// Declare Paystack on window object
declare global {
  interface Window {
    PaystackPop: any;
  }
}
const cities = [{
  id: 'benin',
  name: 'Benin',
  date: 'April 18th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'March 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/Gg0acDUlz9WKb1bu4EPeEf'
}, {
  id: 'lagos',
  name: 'Lagos',
  date: 'May 2nd, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'April 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh'
}, {
  id: 'asaba',
  name: 'Asaba',
  date: 'May 16th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'April 2026',
  price: 4500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/DkaarUKWs7aJ6crRvDPOpt'
}, {
  id: 'uyo',
  name: 'Uyo',
  date: 'June 20th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'May 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/IJAovNsQlYb0lqR9wGcBvL'
}, {
  id: 'abuja',
  name: 'Abuja',
  date: 'July 6th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'June 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/KyuLep5qjEwHU6VR8tiBW9'
}, {
  id: 'calabar',
  name: 'Calabar',
  date: 'July 4th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'June 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/placeholder-calabar'
}, {
  id: 'ogbomosho',
  name: 'Ogbomosho',
  date: 'July 18th, 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'June 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/placeholder-ogbomosho'
}, {
  id: 'warri',
  name: 'Warri',
  date: 'July 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'June 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/placeholder-warri'
}, {
  id: 'port-harcourt',
  name: 'Port Harcourt',
  date: 'July 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'June 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/placeholder-portharcourt'
}, {
  id: 'canada',
  name: 'Canada',
  date: 'March 2026',
  time: null,
  earlyBirdDeadline: null,
  price: 10,
  regularPrice: 10,
  currency: 'USD',
  whatsapp: 'https://chat.whatsapp.com/EoH9cpC9aKf3UpVkypIJ8U',
  note: 'Payment unlocks Canada Networking Salon + Authority Engine Program'
}];
const previousSalonImages = ['https://cdn.magicpatterns.com/uploads/m5JGyWHTaDkAamj98wMGb7/IMG_6814.jpg', 'https://cdn.magicpatterns.com/uploads/2nbgMJBreHEfdmtK4vgrbJ/IMG_6832.jpg', 'https://cdn.magicpatterns.com/uploads/jnvfWnPf1cGdFuPZB9E2Zr/IMG_6896.jpg', 'https://cdn.magicpatterns.com/uploads/uaDfSY9NcCTXCVXkMyx1fb/IMG_7057.jpg', 'https://cdn.magicpatterns.com/uploads/7udF6MBUoAVRsQvjSHtT4c/IMG_7107.jpg', 'https://cdn.magicpatterns.com/uploads/8RNPHJGX9qBcGJfRDv1bKe/9E5A0116.jpg', 'https://cdn.magicpatterns.com/uploads/cQTusuTum4AGg19vNk8p6d/a27.jpg', 'https://cdn.magicpatterns.com/uploads/2xJjafNwsvs9iwnVTW9ejF/IMG_7290.jpg', 'https://cdn.magicpatterns.com/uploads/sP1AwUgBGEHhpiahzTd9b5/IMG_7305.jpg', 'https://cdn.magicpatterns.com/uploads/5WG1zLXYrsLdH2Tu3Hpc3m/IMG_7320.jpg', 'https://cdn.magicpatterns.com/uploads/9XTZkxvACPBaeCCvyLqoaa/SAV_8260.jpg', 'https://cdn.magicpatterns.com/uploads/tEcWAQhU5r3SoCg4m6csn8/SAV_8309.jpg', 'https://cdn.magicpatterns.com/uploads/1eUP3VkLsTvbJKiCJverQv/SAV_8332.jpg', 'https://cdn.magicpatterns.com/uploads/4sBVqYid4ahg9dxKEsLi3U/SAV_8340.jpg', 'https://cdn.magicpatterns.com/uploads/xuS1vdg3FiU6SAokqFyiMx/SAV_8448.jpg', 'https://cdn.magicpatterns.com/uploads/jeLMdPXGp5SXnexoxKaqFw/unnamed_(6).jpg', 'https://cdn.magicpatterns.com/uploads/3MEKv6XzUhgyymd5UfWmGf/dfgs.png', 'https://cdn.magicpatterns.com/uploads/vHh2G6bgrJBYnknDMcXMtZ/IMG_7208.jpg', 'https://cdn.magicpatterns.com/uploads/aGKUBFd9h3tDbMZC6hJaiY/SAV_8449.jpg', 'https://cdn.magicpatterns.com/uploads/a7kidJR6Pc9x3GhsF58NyE/IMG-20220824-WA0124.jpg', 'https://cdn.magicpatterns.com/uploads/xsJXSEdL6Y68W1dg6bQPja/IMG-20260215-WA0002.jpg', 'https://cdn.magicpatterns.com/uploads/16nbs26oxMA5rsgoBXcUBa/IMG-20260215-WA0006.jpg', 'https://cdn.magicpatterns.com/uploads/bAx1SFdmgZKsswoxrZEhQy/IMG-20260215-WA0007.jpg', 'https://cdn.magicpatterns.com/uploads/s6ui6XAHmWQ2uJQabcqBcM/IMG-20260304-WA0007.jpg', 'https://cdn.magicpatterns.com/uploads/hSFYh7o2zekmc4ij12K9Bj/IMG-20260304-WA0008.jpg'];
const heroSliderImages = ['https://cdn.magicpatterns.com/uploads/m5JGyWHTaDkAamj98wMGb7/IMG_6814.jpg', 'https://cdn.magicpatterns.com/uploads/8RNPHJGX9qBcGJfRDv1bKe/9E5A0116.jpg', 'https://cdn.magicpatterns.com/uploads/9XTZkxvACPBaeCCvyLqoaa/SAV_8260.jpg', 'https://cdn.magicpatterns.com/uploads/1eUP3VkLsTvbJKiCJverQv/SAV_8332.jpg', 'https://cdn.magicpatterns.com/uploads/s6ui6XAHmWQ2uJQabcqBcM/IMG-20260304-WA0007.jpg'];
const testimonialQuotes = [{
  quote: 'I came expecting a talk. I left with a whole new direction for my brand.',
  name: 'Adaeze O.',
  role: 'Brand Strategist'
}, {
  quote: "The connections I made at the Salon opened doors I'd been knocking on for months.",
  name: 'Tunde M.',
  role: 'Tech Founder'
}, {
  quote: 'No fluff, no filler — just real conversations with people who get it.',
  name: 'Blessing E.',
  role: 'Content Creator'
}, {
  quote: 'I finally understood what positioning means. This changed how I show up online.',
  name: 'Chidi A.',
  role: 'Consultant'
}];
export function NetworkingSalonExperiencePage({
  onNavigate
}: NetworkingSalonExperiencePageProps) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isRegistering, setIsRegistering] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentHeroImage, setCurrentHeroImage] = useState(0);
  const [galleryPaused, setGalleryPaused] = useState(false);
  const galleryRef = useRef<HTMLDivElement>(null);
  // Form State
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    expertise: '',
    goal: '',
    instagram: '',
    twitter: '',
    tiktok: '',
    facebook: ''
  });
  // Hero Slider Effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeroImage(prev => (prev + 1) % heroSliderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  // Load Paystack Script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  const scrollGallery = (direction: 'left' | 'right') => {
    if (galleryRef.current) {
      const scrollAmount = 300;
      galleryRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCitySelect = (cityId: string) => {
    if (selectedCityId === cityId) {
      // If clicking the same city, just scroll to registration if it's already open
      if (isRegistering) {
        scrollToElement('registration-form');
      } else {
        setSelectedCityId(null);
      }
    } else {
      setSelectedCityId(cityId);
    }
  };
  const proceedToRegistration = () => {
    setIsRegistering(true);
    setTimeout(() => {
      scrollToElement('registration-form');
    }, 100);
  };
  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.fullName || !formData.email || !formData.phone) {
        alert('Please fill in all required fields');
        return;
      }
    } else if (currentStep === 2) {
      if (!formData.expertise || !formData.goal) {
        alert('Please fill in all required fields');
        return;
      }
    } else if (currentStep === 3) {
      if (!formData.instagram || !formData.twitter || !formData.tiktok || !formData.facebook) {
        alert('Please answer all community check questions');
        return;
      }
    }
    setCurrentStep(prev => prev + 1);
  };
  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };
  const handlePayment = async () => {
    if (!selectedCityId) return;
    const city = cities.find(c => c.id === selectedCityId);
    if (!city) return;
    setIsSubmitting(true);
    try {
      const formspreeData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        expertise: formData.expertise,
        goal: formData.goal,
        city: city.name,
        instagram: formData.instagram,
        twitter: formData.twitter,
        tiktok: formData.tiktok,
        facebook: formData.facebook
      };
      await fetch('https://script.google.com/macros/s/AKfycbzR_-KmqKZFGGbKzHfTDJ1Shbo07C0RSOwx4RKTH9sU4PjA-r7elviN739j-03EfNIa/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formspreeData)
      });
    } catch (error) {
      console.error('Form submission error:', error);
    }
    setIsSubmitting(false);
    const handler = window.PaystackPop.setup({
      key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
      email: formData.email,
      amount: city.currency === 'USD' ? city.price * 100 : city.price,
      currency: city.currency,
      ref: 'NSE_' + city.id.toUpperCase() + '_' + Math.floor(Math.random() * 1000000000 + 1),
      metadata: {
        custom_fields: [{
          display_name: 'Full Name',
          variable_name: 'full_name',
          value: formData.fullName
        }, {
          display_name: 'Phone Number',
          variable_name: 'phone',
          value: formData.phone
        }, {
          display_name: 'City',
          variable_name: 'city',
          value: city.name
        }, {
          display_name: 'Expertise',
          variable_name: 'expertise',
          value: formData.expertise
        }]
      },
      callback: function (response: any) {
        alert(`You're In! Welcome to The Networking Salon Experience in ${city.name}. Redirecting you to the city WhatsApp group...`);
        window.location.href = city.whatsapp;
      },
      onClose: function () {
        console.log('Payment cancelled');
      }
    });
    handler.openIframe();
  };
  const scrollToElement = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933] font-sans selection:bg-salon-red/20 selection:text-[#1f2933]" data-id="element-1390">
      {/* CSS Animations */}
      <style data-id="element-1391">{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .gallery-scroll {
          animation: scroll 45s linear infinite;
        }
        .gallery-scroll.paused {
          animation-play-state: paused;
        }
        .gallery-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* CUSTOM SALON NAVBAR */}
      <nav className="sticky top-0 z-50 w-full bg-[#1f2933] text-white shadow-md" data-id="element-1392">
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-1393">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => onNavigate && onNavigate('/')} data-id="element-1394">
            <img src="https://cdn.magicpatterns.com/uploads/dKtihEU4NjCWDRS7TF9QX8/2-3_100310.png" alt="The Networking Salon" loading="lazy" className="h-20 w-auto brightness-150 contrast-125" data-id="element-1395" />
          </div>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-1396">
            <button onClick={() => scrollToElement('what-youll-learn')} className="text-sm font-bold hover:text-salon-red transition-colors" data-id="element-1397">
              WHAT YOU'LL LEARN
            </button>
            <button onClick={() => scrollToElement('the-experience')} className="text-sm font-bold hover:text-salon-red transition-colors" data-id="element-1398">
              THE EXPERIENCE
            </button>
            <button onClick={() => scrollToElement('cities')} className="text-sm font-bold hover:text-salon-red transition-colors" data-id="element-1399">
              LOCATIONS
            </button>
            <Button onClick={() => scrollToElement('cities')} className="bg-salon-red hover:bg-salon-red/90 border-salon-red text-white font-bold rounded-full px-6" data-id="element-1400">
              REGISTER NOW
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-1401">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-1402" /> : <MenuIcon className="w-6 h-6" data-id="element-1403" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="lg:hidden absolute top-20 left-0 w-full bg-[#1f2933] border-t border-gray-700 p-4 flex flex-col gap-4 shadow-xl" data-id="element-1404">
            <button onClick={() => scrollToElement('what-youll-learn')} className="text-left text-sm font-bold p-2 hover:text-salon-red" data-id="element-1405">
              WHAT YOU'LL LEARN
            </button>
            <button onClick={() => scrollToElement('the-experience')} className="text-left text-sm font-bold p-2 hover:text-salon-red" data-id="element-1406">
              THE EXPERIENCE
            </button>
            <button onClick={() => scrollToElement('cities')} className="text-left text-sm font-bold p-2 hover:text-salon-red" data-id="element-1407">
              LOCATIONS
            </button>
            <Button onClick={() => scrollToElement('cities')} className="bg-salon-red border-salon-red text-white w-full mt-2" data-id="element-1408">
              REGISTER NOW
            </Button>
          </div>}
      </nav>

      {/* HERO SECTION */}
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-[#1f2933]" data-id="element-1409">
        {/* B&W Image Slider Background */}
        <div className="absolute inset-0 z-0" data-id="element-1410">
          {heroSliderImages.map((img, idx) => <div key={idx} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${idx === currentHeroImage ? 'opacity-100' : 'opacity-0'}`} data-id="element-1411">
              <img src={img} alt="Networking Salon Event" loading="lazy" className="w-full h-full object-cover grayscale opacity-30" data-id="element-1412" />
            </div>)}
          {/* Dark overlay gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#1f2933] via-[#1f2933]/80 to-transparent" data-id="element-1413" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1f2933]/90 via-transparent to-[#1f2933]/90" data-id="element-1414" />
        </div>

        <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center pt-12 pb-20" data-id="element-1415">
          <Badge className="mb-6 bg-salon-red/20 text-salon-red border-salon-red/30 px-4 py-1.5 rounded-full font-bold tracking-widest text-xs" data-id="element-1416">
            2026 TOUR
          </Badge>

          <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-1417">
            STOP WORKING HARD IN SILENCE. <br className="hidden md:block" data-id="element-1418" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-1419">
              START BUILDING AUTHORITY, VISIBILITY & INCOME.
            </span>
          </h1>

          <p className="mx-auto max-w-3xl text-lg md:text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-1420">
            A full-day co-working experience for business owners, creators &
            career professionals who are ready to level up their brand, content,
            and income using AI and smart strategy.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-1421">
            <Button size="large" onClick={() => scrollToElement('cities')} className="w-full sm:w-auto bg-salon-red hover:bg-red-700 border-salon-red text-white rounded-full px-8 py-4 text-lg font-bold shadow-lg shadow-salon-red/20" data-id="element-1422">
              CHOOSE YOUR CITY
            </Button>
            <Button variant="secondary" size="large" onClick={() => scrollToElement('what-youll-learn')} className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-[#1f2933] rounded-full px-8 py-4 text-lg font-bold transition-all" data-id="element-1423">
              SEE WHAT YOU'LL LEARN
            </Button>
          </div>

          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/10" data-id="element-1424">
            <span className="text-xl" data-id="element-1425">🔥</span>
            <p className="text-sm md:text-base text-white font-medium" data-id="element-1426">
              Bring your laptop. Bring your phone. Leave with 30 days of
              content.
            </p>
          </div>
        </div>
      </section>

      {/* B&W GALLERY SLIDER */}
      <section className="py-12 bg-[#1f2933] overflow-hidden border-t border-white/10" data-id="element-1427">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-8" data-id="element-1428">
          <div className="flex items-center justify-between" data-id="element-1429">
            <div data-id="element-1430">
              <h2 className="text-2xl font-bold text-white mb-1" data-id="element-1431">
                PREVIOUS SALONS
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-1432">
                Abuja, Lagos, Port Harcourt, Berlin, Warri, Benin
              </p>
            </div>
            <div className="flex gap-2" data-id="element-1433">
              <button onClick={() => scrollGallery('left')} className="w-10 h-10 rounded-full border border-gray-600 text-white flex items-center justify-center hover:bg-white/10 transition-colors" data-id="element-1434">
                ←
              </button>
              <button onClick={() => scrollGallery('right')} className="w-10 h-10 rounded-full border border-gray-600 text-white flex items-center justify-center hover:bg-white/10 transition-colors" data-id="element-1435">
                →
              </button>
              <button onClick={() => setGalleryPaused(!galleryPaused)} className="w-10 h-10 rounded-full border border-gray-600 text-white flex items-center justify-center hover:bg-white/10 transition-colors text-xs" data-id="element-1436">
                {galleryPaused ? '▶' : '❚❚'}
              </button>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-1437">
          <div ref={galleryRef} className={`flex gallery-scroll ${galleryPaused ? 'paused' : ''}`} style={{
          width: 'max-content'
        }} data-id="element-1438">
            {[...previousSalonImages, ...previousSalonImages].map((img, idx) => <div key={idx} className="flex-shrink-0 w-64 h-64 sm:w-80 sm:h-80 mx-3 rounded-xl overflow-hidden group" data-id="element-1439">
                  <img src={img} alt={`Previous Salon ${idx % previousSalonImages.length + 1}`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 transform group-hover:scale-105" loading="lazy" data-id="element-1440" />
                </div>)}
          </div>
        </div>
      </section>

      {/* WHAT YOU'LL LEARN SECTION */}
      <section id="what-youll-learn" className="py-24 bg-[#f5f5f7]" data-id="element-1441">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1442">
          <div className="text-center mb-16" data-id="element-1443">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#1f2933] mb-4" data-id="element-1444">
              WHAT YOU'LL LEARN & DO
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-1445">
              Practical. Hands-on. No fluff.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1446">
            {[{
            icon: CrownIcon,
            title: 'Build Authority in Your Field',
            desc: "Learn how to position yourself as the go-to expert in your industry, even if you're just starting out."
          }, {
            icon: HandshakeIcon,
            title: 'Build Relationships That Move You Forward',
            desc: 'Master the art of strategic networking — connect with people who can open real doors for you.'
          }, {
            icon: SparklesIcon,
            title: 'Use AI to Create Multiple Content Pieces',
            desc: 'Turn one idea into 10+ pieces of content using AI tools — posts, threads, carousels, and more.'
          }, {
            icon: CalendarCheckIcon,
            title: 'Schedule 30 Days of Content',
            desc: 'Walk away with a full month of content scheduled on Facebook, TikTok, Instagram & LinkedIn. Done. Sorted.'
          }, {
            icon: GlobeIcon,
            title: 'Use AI to Build Websites & Mini Apps',
            desc: 'Learn how to use AI to create landing pages, portfolios, and mini tools for your business — no coding needed.'
          }, {
            icon: VideoIcon,
            title: 'Create Talking Head Video Content',
            desc: "Record your first (or best) talking head videos with guidance, even if you've never been on camera before."
          }, {
            icon: TrendingUp,
            title: 'The New Rules of Business Growth',
            desc: 'Understand the modern playbook for growing a business with the right structure, systems, and strategy.'
          }, {
            icon: LayersIcon,
            title: 'Multiple Streams of Income (21st Century Style)',
            desc: 'Discover how to create and stack income streams using your skills, content, and digital tools.'
          }, {
            icon: FileTextIcon,
            title: 'LinkedIn Newsletters Like Top Executives',
            desc: 'Learn the exact strategy top professionals use to build massive audiences through LinkedIn newsletters.'
          }].map((item, idx) => <div key={idx} className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-salon-red group relative overflow-hidden" data-id="element-1447">
                <div className="absolute top-0 right-0 text-9xl font-black text-gray-50 opacity-50 -mt-8 -mr-4 pointer-events-none group-hover:text-red-50 transition-colors" data-id="element-1448">
                  {idx + 1}
                </div>
                <div className="relative z-10" data-id="element-1449">
                  <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-salon-red transition-colors" data-id="element-1450">
                    <item.icon className="w-7 h-7 text-salon-red group-hover:text-white transition-colors" data-id="element-1451" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1f2933] mb-3 leading-tight" data-id="element-1452">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1453">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* THE EXPERIENCE SECTION */}
      <section id="the-experience" className="py-24 bg-[#1f2933] text-white" data-id="element-1454">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1455">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-1456">
            <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-1457">
              MORE THAN A SEMINAR.
              <br data-id="element-1458" />
              IT'S AN EXPERIENCE.
            </h2>
            <p className="text-xl text-salon-red font-bold mb-6" data-id="element-1459">
              Come ready to work. Leave ready to win.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-1460">
              Think co-working space meets creative studio. Bring your laptop,
              phone, ring light, lapel mic — whatever tools you use. This is a
              hands-on, practical session where you'll actually DO the work.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-id="element-1461">
            {[{
            emoji: '☕',
            title: 'Breakfast',
            desc: 'Start the day fueled and focused'
          }, {
            emoji: '🍽️',
            title: 'Lunch',
            desc: 'Network over a great meal'
          }, {
            emoji: '🎮',
            title: 'Games',
            desc: 'Break the ice and have fun'
          }, {
            emoji: '🎉',
            title: 'Fun',
            desc: 'Because growth should feel good'
          }, {
            emoji: '🤝',
            title: 'Networking',
            desc: 'Meet people who get it'
          }, {
            emoji: '💻',
            title: 'Hands-on Sessions',
            desc: 'Actually build and create'
          }].map((item, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center hover:bg-white/10 transition-colors" data-id="element-1462">
                <div className="text-4xl mb-4" data-id="element-1463">{item.emoji}</div>
                <h4 className="text-lg font-bold mb-2" data-id="element-1464">{item.title}</h4>
                <p className="text-sm text-gray-400" data-id="element-1465">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CHOOSE YOUR LOCATION SECTION */}
      <section id="cities" className="py-24 bg-white" data-id="element-1466">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1467">
          <div className="text-center mb-16" data-id="element-1468">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#1f2933] mb-4" data-id="element-1469">
              CHOOSE YOUR CITY
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-1470">
              We're coming to 10 cities. Find yours.
            </p>
          </div>

          {/* City Selector Grid */}
          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-1471">
            {cities.map(city => <button key={city.id} onClick={() => handleCitySelect(city.id)} className={`px-6 py-3 rounded-full font-bold text-sm md:text-base transition-all duration-300 shadow-sm ${selectedCityId === city.id ? 'bg-salon-red text-white shadow-salon-red/30 shadow-lg scale-105' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105'}`} data-id="element-1472">
                <div className="flex items-center gap-2" data-id="element-1473">
                  <MapPinIcon className="w-4 h-4" data-id="element-1474" />
                  {city.name}
                </div>
              </button>)}
          </div>

          {/* Selected City Details Panel */}
          {selectedCityId && <div className="max-w-3xl mx-auto bg-[#1f2933] rounded-3xl p-8 md:p-12 shadow-2xl text-white transform transition-all animate-in fade-in slide-in-from-bottom-4" data-id="element-1475">
              {cities.filter(c => c.id === selectedCityId).map(city => <div key={city.id} className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1476">
                    <div className="flex-1 text-center md:text-left" data-id="element-1477">
                      <h3 className="text-4xl font-black mb-4" data-id="element-1478">
                        {city.name} Edition
                      </h3>

                      <div className="space-y-3 mb-6" data-id="element-1479">
                        <div className="flex items-center justify-center md:justify-start gap-3 text-gray-300" data-id="element-1480">
                          <Calendar className="w-5 h-5 text-salon-red" data-id="element-1481" />
                          <span className="text-lg" data-id="element-1482">{city.date}</span>
                        </div>
                        {city.time && <div className="flex items-center justify-center md:justify-start gap-3 text-gray-300" data-id="element-1483">
                            <Clock className="w-5 h-5 text-salon-red" data-id="element-1484" />
                            <span className="text-lg" data-id="element-1485">{city.time}</span>
                          </div>}
                      </div>

                      {city.id === 'canada' ? <div className="bg-white/10 rounded-xl p-4 inline-block text-left border border-white/20" data-id="element-1486">
                          <p className="text-sm text-gray-400 mb-1" data-id="element-1487">
                            Total Payment
                          </p>
                          <p className="text-3xl font-bold text-white mb-2" data-id="element-1488">
                            $10.00 USD
                          </p>
                          <p className="text-xs text-salon-red font-medium" data-id="element-1489">
                            {city.note}
                          </p>
                        </div> : <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-1490">
                          <div className="bg-salon-red/20 border border-salon-red/50 rounded-xl p-4 flex-1" data-id="element-1491">
                            <p className="text-xs font-bold text-salon-red uppercase tracking-wider mb-1" data-id="element-1492">
                              Early Bird
                            </p>
                            <p className="text-3xl font-bold text-white mb-1" data-id="element-1493">
                              ₦35,000
                            </p>
                            <p className="text-xs text-gray-400" data-id="element-1494">
                              Valid until {city.earlyBirdDeadline}
                            </p>
                          </div>
                          <div className="bg-white/5 border border-white/10 rounded-xl p-4 flex-1" data-id="element-1495">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-1496">
                              Regular
                            </p>
                            <p className="text-3xl font-bold text-gray-300 mb-1" data-id="element-1497">
                              ₦50,000
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-1498">
                              Standard pricing
                            </p>
                          </div>
                        </div>}
                    </div>

                    <div className="w-full md:w-auto flex flex-col items-center" data-id="element-1499">
                      <Button size="large" onClick={proceedToRegistration} className="w-full md:w-auto bg-salon-red hover:bg-red-700 border-salon-red text-white rounded-full px-8 py-4 text-lg font-bold shadow-lg shadow-salon-red/20 whitespace-nowrap" data-id="element-1500">
                        REGISTER FOR {city.name.toUpperCase()}
                      </Button>
                      <p className="text-xs text-gray-500 mt-4 text-center" data-id="element-1501">
                        Secure payment via Paystack
                      </p>
                    </div>
                  </div>)}
            </div>}
        </div>
      </section>

      {/* REGISTRATION FORM */}
      {isRegistering && selectedCityId && <section id="registration-form" className="py-24 bg-[#f5f5f7]" data-id="element-1502">
          <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8" data-id="element-1503">
            <div className="text-center mb-10" data-id="element-1504">
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2933] mb-3" data-id="element-1505">
                Complete Registration
              </h2>
              <div className="flex items-center justify-center gap-2 text-sm font-bold text-salon-red" data-id="element-1506">
                <span className={`w-6 h-6 rounded-full flex items-center justify-center ${currentStep >= 1 ? 'bg-salon-red text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-1507">
                  1
                </span>
                <div className={`w-8 h-1 rounded-full ${currentStep >= 2 ? 'bg-salon-red' : 'bg-gray-200'}`} data-id="element-1508"></div>
                <span className={`w-6 h-6 rounded-full flex items-center justify-center ${currentStep >= 2 ? 'bg-salon-red text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-1509">
                  2
                </span>
                <div className={`w-8 h-1 rounded-full ${currentStep >= 3 ? 'bg-salon-red' : 'bg-gray-200'}`} data-id="element-1510"></div>
                <span className={`w-6 h-6 rounded-full flex items-center justify-center ${currentStep >= 3 ? 'bg-salon-red text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-1511">
                  3
                </span>
              </div>
              <p className="text-gray-500 mt-4 font-medium" data-id="element-1512">
                {cities.find(c => c.id === selectedCityId)?.name} Edition
              </p>
            </div>

            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-gray-100" data-id="element-1513">
              {/* Step 1: Personal Info */}
              {currentStep === 1 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1514">
                  <h3 className="text-2xl font-bold text-[#1f2933] mb-6" data-id="element-1515">
                    Personal Information
                  </h3>

                  <div className="space-y-4" data-id="element-1516">
                    <div data-id="element-1517">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-1518">
                        Full Name
                      </label>
                      <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-salon-red focus:ring-0 transition-colors outline-none" placeholder="Enter your full name" data-id="element-1519" />
                    </div>
                    <div data-id="element-1520">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-1521">
                        Email Address
                      </label>
                      <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-salon-red focus:ring-0 transition-colors outline-none" placeholder="Enter your email" data-id="element-1522" />
                    </div>
                    <div data-id="element-1523">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-1524">
                        Phone Number
                      </label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-salon-red focus:ring-0 transition-colors outline-none" placeholder="Enter your phone number" data-id="element-1525" />
                    </div>
                  </div>

                  <Button onClick={nextStep} size="large" className="w-full bg-[#1f2933] hover:bg-black border-[#1f2933] text-white rounded-xl mt-8 font-bold" data-id="element-1526">
                    CONTINUE TO NEXT STEP
                  </Button>
                </div>}

              {/* Step 2: Professional Info */}
              {currentStep === 2 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1527">
                  <h3 className="text-2xl font-bold text-[#1f2933] mb-6" data-id="element-1528">
                    Professional Information
                  </h3>

                  <div className="space-y-4" data-id="element-1529">
                    <div data-id="element-1530">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-1531">
                        Area of Expertise
                      </label>
                      <input type="text" name="expertise" value={formData.expertise} onChange={handleInputChange} className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-salon-red focus:ring-0 transition-colors outline-none" placeholder="What do you do?" data-id="element-1532" />
                    </div>
                    <div data-id="element-1533">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-1534">
                        Goal for Attending
                      </label>
                      <textarea name="goal" value={formData.goal} onChange={handleInputChange} rows={4} className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-salon-red focus:ring-0 transition-colors outline-none resize-none" placeholder="What do you hope to achieve?" data-id="element-1535" />
                    </div>
                  </div>

                  <div className="flex gap-4 mt-8" data-id="element-1536">
                    <Button variant="secondary" onClick={prevStep} size="large" className="flex-1 rounded-xl font-bold border-2 border-gray-200 text-gray-600 hover:bg-gray-50" data-id="element-1537">
                      BACK
                    </Button>
                    <Button onClick={nextStep} size="large" className="flex-[2] bg-[#1f2933] hover:bg-black border-[#1f2933] text-white rounded-xl font-bold" data-id="element-1538">
                      CONTINUE
                    </Button>
                  </div>
                </div>}

              {/* Step 3: Community Check & Payment */}
              {currentStep === 3 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1539">
                  <h3 className="text-2xl font-bold text-[#1f2933] mb-2" data-id="element-1540">
                    Community Check
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-1541">
                    Are you following The Networking Salon on these platforms?
                  </p>

                  <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-1542">
                    {['Instagram', 'Twitter/X', 'TikTok', 'Facebook'].map(platform => <div key={platform} className="border-2 border-gray-100 bg-gray-50 p-4 rounded-xl" data-id="element-1543">
                          <p className="font-bold text-sm text-gray-700 mb-2" data-id="element-1544">
                            {platform}
                          </p>
                          <select name={platform.toLowerCase().replace('/x', '')} value={formData[platform.toLowerCase().replace('/x', '') as keyof typeof formData]} onChange={handleInputChange} className="w-full border-2 border-gray-200 rounded-lg p-2 text-sm focus:border-salon-red outline-none bg-white" data-id="element-1545">
                            <option value="" data-id="element-1546">Select...</option>
                            <option value="yes" data-id="element-1547">Yes</option>
                            <option value="no" data-id="element-1548">No</option>
                          </select>
                        </div>)}
                  </div>

                  <div className="bg-red-50 border border-red-100 p-6 rounded-2xl mb-8" data-id="element-1549">
                    {selectedCityId !== 'canada' ? <>
                        <div className="flex justify-between items-center mb-2" data-id="element-1550">
                          <span className="font-bold text-gray-800" data-id="element-1551">
                            Amount Due Today:
                          </span>
                          <span className="text-2xl font-black text-salon-red" data-id="element-1552">
                            ₦35,000
                          </span>
                        </div>
                        <p className="text-sm text-red-800 font-medium" data-id="element-1553">
                          Early Bird Pricing Applied
                        </p>
                      </> : <>
                        <div className="flex justify-between items-center mb-2" data-id="element-1554">
                          <span className="font-bold text-gray-800" data-id="element-1555">
                            Amount Due Today:
                          </span>
                          <span className="text-2xl font-black text-salon-red" data-id="element-1556">
                            $10.00
                          </span>
                        </div>
                        <p className="text-sm text-red-800 font-medium" data-id="element-1557">
                          Includes Authority Engine Access
                        </p>
                      </>}
                  </div>

                  <div className="flex gap-4" data-id="element-1558">
                    <Button variant="secondary" onClick={prevStep} size="large" className="flex-1 rounded-xl font-bold border-2 border-gray-200 text-gray-600 hover:bg-gray-50" data-id="element-1559">
                      BACK
                    </Button>
                    <Button onClick={handlePayment} size="large" className="flex-[2] bg-salon-red hover:bg-red-700 border-salon-red text-white rounded-xl font-bold shadow-lg shadow-salon-red/20" disabled={isSubmitting} data-id="element-1560">
                      {isSubmitting ? <span className="flex items-center justify-center gap-2" data-id="element-1561">
                          <Loader2 className="w-5 h-5 animate-spin" data-id="element-1562" />
                          PROCESSING...
                        </span> : 'COMPLETE PAYMENT'}
                    </Button>
                  </div>
                </div>}
            </div>
          </div>
        </section>}

      {/* TESTIMONIALS */}
      <section className="py-24 bg-white overflow-hidden" data-id="element-1563">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1564">
          <div className="text-center mb-16" data-id="element-1565">
            <h2 className="text-4xl font-extrabold text-[#1f2933] mb-4" data-id="element-1566">
              WHAT PAST ATTENDEES SAY
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1567">
            {testimonialQuotes.map((t, idx) => <div key={idx} className="bg-gray-50 rounded-2xl p-8 border border-gray-100 relative" data-id="element-1568">
                <div className="text-4xl text-gray-300 font-serif absolute top-6 left-6" data-id="element-1569">
                  "
                </div>
                <p className="text-gray-700 font-medium mb-6 relative z-10 pt-6" data-id="element-1570">
                  {t.quote}
                </p>
                <div data-id="element-1571">
                  <p className="font-bold text-[#1f2933]" data-id="element-1572">{t.name}</p>
                  <p className="text-sm text-salon-red font-bold" data-id="element-1573">{t.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="py-32 bg-salon-red text-white text-center px-4" data-id="element-1574">
        <div className="mx-auto max-w-4xl" data-id="element-1575">
          <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight" data-id="element-1576">
            Your next level requires the right room, the right tools, and the
            right strategy.
          </h2>
          <p className="text-xl md:text-2xl font-medium text-red-100 mb-12 max-w-2xl mx-auto" data-id="element-1577">
            Don't just consume content. Create it.{' '}
            <br className="hidden md:block" data-id="element-1578" />
            Don't just attend events. Leave transformed.
          </p>
          <Button size="large" className="bg-white text-salon-red hover:bg-gray-100 border-white rounded-full px-10 py-5 text-xl font-black shadow-2xl" onClick={() => scrollToElement('cities')} data-id="element-1579">
            FIND YOUR CITY
          </Button>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1580" />
    </div>;
}